module.exports = __webpack_public_path__ + "static/media/advancejava.5120d96b.png";